/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-01-03 21:21:35
* @Last Modified by:   Bolt
* @Last Modified time: 2017-03-10 16:29:42
*/

'use strict';

import './buy.less';
import Footer from '@souche-f2e/wangzhan-modularity-footer';
import VuePosition from '@souche-vue/vue-position';

import Vue from 'vue';
import Store from 'store';
import NavContainer from '../components-buy/ListContain/NavContainer.vue';
import CarNav from '../components-buy/ListContain/ListMain/CarNav.vue';
import CardBox from '../components-buy/ListContain/ListMain/CardBox.vue';
import ListBox from '../components-buy/ListContain/ListMain/ListBox.vue';
import OtherShop from '../components-buy/ListContain/ListMain/OtherShop.vue';

Vue.use(VuePosition, {
    http: true,
    province: true
});

// listContain
// 内部代码全部实现 Vue 时，整体使用一个 new Vue()
(() => {
    // navContainer
    // 内部代码全部实现 Vue 时，整体使用一个 new Vue()
    let appNavContainer = new Vue(NavContainer);
    appNavContainer.$mount('.navContainer');
    // list_main
    // 内部代码全部实现 Vue 时，整体使用一个 new Vue()
    (() => {
        // .car-nav
        let appCarNav = new Vue(CarNav);
        appCarNav.$mount('.car-nav');

        // card-box
        let appCardBox = new Vue(CardBox);
        appCardBox.$mount('.card-box');

        // list-box
        let appListBox = new Vue(ListBox);
        appListBox.$mount('.list-box');

        // other-shop
        let appOtherShop = new Vue(OtherShop);
        appOtherShop.$mount('.other-shop');
    })();
})();

let appFooter = new Vue(Footer);
appFooter.$mount('.footer');

// require('../components-buy/riot/Betty.js');

(function (w, $) {
    /**
    *   给每辆车增加最后成交时间
    */
    $('.card-box.car-wrap.sold .carItem').each(function(index, el) {
        var carId = $(el).attr('data-id');
        if (carId) {
            $.ajax({
                url: ' /json/car/getLastOrderDate.json',
                type: 'GET',
                dataType: 'json',
                data: {
                    carId: carId
                }
            })
            .done(function(json) {
                if (json.code === 0) {
                    $(el).find('.car-price').append(`<span style="color: #999;">成交于:${json.item}</span>`);
                }
            })
            .fail(function() {
                // console.log('error');
            })
            .always(function() {
                // console.log('complete');
            });
        }
    });
})(window, window.jQuery);

// 神州租车准新车
(function () {
    let $ = window.$;
    if (window._qiwa && window._qiwa.__site_basic.siteId === '233') {
        $('.price-unit').each(function(index, el) {
            $(el).text(`${$(el).text()}起`);
        });
    }
})();

(function () {
    const app = new Vue();
    app.$getPosition().then((res) => {
        if (res.latitude && res.longitude) {
            Store.set('USER_COORDINATE', res);
        }
    }).catch((err) => {
        console.log('bolt_err', err);
        var iframe = document.createElement('iframe');
        iframe.src = window.location.href;
        iframe.style = 'visibility: hidden; position: absolute; top: -1000px;';
        document.body.appendChild(iframe);
    });
})();



// WEBPACK FOOTER //
// ./src/pages/buy.js